import React, { useContext } from 'react';
import PageGridItem from '../../../Shared/Page/PageGridItem';
import { PageContentBodyGrid } from '../../../Shared/Page/Page';
import DetailSectionHeader from '../../../Shared/DetailSection/DetailSectionHeader';
import DetailField from '../../../Shared/DetailSection/DetailField';
import { format, parseISO } from 'date-fns';
import { SchemeContext } from '../SchemePage';
import SimpleSearchFilter, { filterBy } from '../../../../components/Input/SimpleSearchFilter';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { PAGES, ROUTE_PATHS } from '../../../../InternalApiApp';
import { ChevronRight, FileText, Search, Users } from 'react-feather';
import DetailFieldList from '../../../Shared/DetailSection/DetailFieldList';
import Table from '../../../../components/Table/Table';
import useWindowDimensions from '../../../../Utils/Utils';

const SchemeGeneral = ({ portfolio }) => {
	const history = useHistory();
	const { width } = useWindowDimensions()


	const { scheme, editMode, searchTerm, setSearchTerm, list, updateScheme } = useContext(SchemeContext)

	function filter(dataToFilter) {
		if (searchTerm === null || searchTerm.trim().size === 0) {
			return dataToFilter
		}
		return dataToFilter.filter((datum) => filterBy(datum, ["offerName", "offerNumber"], searchTerm))
	}

	const filteredList = filter(list)
	const colWidths = ['auto']
	const dataMap = (data) => data && data.map((fund, idx) => {
		const { offerName, offerNumber } = fund
		return (
			<tr key={idx} className='cursor-pointer portfolio-mgmt-table-row' onClick={() => history.push(`${ROUTE_PATHS[PAGES.ADMIN]}${portfolio ? '/portfolio-management/products/' : '/fund-management/offers/'}${offerNumber}`)}>
				<td>{portfolio ? offerName : offerName + " " + offerNumber}</td>
				<td className='text-align-right'>
					<ChevronRight className='offer-page-table-chevron' size={16} />
				</td>
			</tr>
		);
	})

	return (
		<>
			<PageGridItem container col="1 / span 6" direction='col' gap="xl" style={{ display: 'flex', paddingRight: '1.5rem' }}>
				<PageContentBodyGrid rowGap="xl" gridColCount="6" subGrid>
					<PageGridItem container col="1 / span 6" >
						<DetailSectionHeader header={portfolio ? "Platform Details" : "Scheme Details"} icon={<FileText />} />
					</PageGridItem>
					<PageGridItem col="1 / span 3">
						<DetailField
							bold
							editMode={editMode}
							onChange={(e) => updateScheme(e.target.value, "schemeName")}
							label={portfolio ? "Platform Name" : "Scheme Name"}
							value={scheme?.schemeName}
						/>
					</PageGridItem>
					<PageGridItem col="4 / span 3">
						<DetailField
							bold
							editMode={editMode}
							onChange={(e) => updateScheme(e.target.value, "schemeNumber")}
							label={portfolio ? "Platform Number" : "Scheme Number"}
							value={scheme?.schemeNumber}
						/>
					</PageGridItem>
					<PageGridItem col="1 / span 3">
						<DetailField
							bold
							editMode={editMode}
							onChange={(e) => updateScheme(e.target.value, "status")}
							label="Status"
							value={scheme?.status}
						/>
					</PageGridItem>
					<PageGridItem col="4 / span 3">
						<DetailFieldList
							bold
							label={portfolio ? "Managed Portfolio Subtypes" : "Managed Fund Subtypes"}
							value={scheme?.subTypes}
						/>
					</PageGridItem>
					<PageGridItem col="1 / span 3">
						<DetailField
							bold
							type="date"
							editMode={editMode}
							onChange={(e) => updateScheme(e.target.value, "dateAdded")}
							label={portfolio ? "Date Platform Registered" : "Date Scheme Registered"}
							value={scheme?.dateAdded}
							renderText={(value) => format(parseISO(value), "dd/MM/yyyy")}
						/>
					</PageGridItem>
					<PageGridItem col="1 / span 3">
						<DetailField
							bold
							editMode={editMode}
							onChange={(e) => updateScheme(e.target.value, "portalPath")}
							label={"Portal path"}
							value={scheme?.portalPath}
						/>
					</PageGridItem>
				</PageContentBodyGrid>
			</PageGridItem>
			<PageGridItem container col="7 / span 6" direction='col' gap="xl" >
				<PageContentBodyGrid rowGap="xl" gridColCount="6" subGrid divider={width < 1200 ? null : 'left'}>
					<PageGridItem container col="1 / span 6">
						<div style={{ display: 'flex', justifyContent: 'space-between', paddingBottom: '1rem' }}>
							<DetailSectionHeader header={portfolio ? "Products" : "Offers"} icon={<Users />} />
							<SimpleSearchFilter
								placeholder={`Search ${portfolio ? "products" : "offers"}`}
								setSearchTerm={setSearchTerm}
								size="small"
								width="m"
								icon={<Search />}
								searchTerm={searchTerm}
							/>
						</div>
						<Table
							minWidth={350}
							tableStyle={{ maxWidth: 1675 }}
							colWidths={colWidths}
							dataMap={dataMap(filteredList)}
							id='scheme-or-platform-list-of-offers-or-products'
						/>
					</PageGridItem>
				</PageContentBodyGrid>
			</PageGridItem>
		</>
	);
}

export default SchemeGeneral;